<template>
  <BadgeDefault
    :borderClass="badgeColorClasses.border"
    :textClass="badgeColorClasses.text"
    id="reservation-status-badge"
  >
    {{ badgeLabel }}
  </BadgeDefault>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue'

import BadgeDefault from '@/common/components/atoms/BadgeDefault.vue'

import { ReservationStatus, ReservationStatusType } from '@generated/types'

export default defineComponent({
  name: 'ReservationStatusBadge',
  components: { BadgeDefault },
  props: {
    status: {
      type: String as PropType<ReservationStatusType>,
      required: true,
    },
  },
  computed: {
    badgeColorClasses(): { text: string; border: string } {
      switch (this.status) {
        case ReservationStatus.ARRIVED:
          return { text: 'text-status-waiting', border: 'border-status-waiting' }
        case ReservationStatus.EXPECTED:
          return { text: 'text-status-expected', border: 'border-status-expected' }
        case ReservationStatus.SEATED:
          return { text: 'text-status-seated', border: 'border-status-seated' }
        case ReservationStatus.CANCELED:
        case ReservationStatus.NO_SHOW:
        case ReservationStatus.UNPAID:
          return { text: 'text-status-noshow', border: 'border-status-noshow' }
        case ReservationStatus.CLEARED:
        default:
          return { text: 'text-status-available', border: 'border-status-available' }
      }
    },
    badgeLabel(): string {
      return this.status === 'unpaid' ? 'Pending' : this.status
    },
  },
})
</script>
